"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var keys_1 = require("../wallet/keys");
function useEphemeralKey() {
    var keyPair = react_1.useState(keys_1.ephemeral)[0];
    return keyPair;
}
exports.useEphemeralKey = useEphemeralKey;
//# sourceMappingURL=useEphemeralKeyHook.js.map